import Tooltip from '@mui/material/Tooltip';

import { MouseClickDragIcon } from '#components/mouse-interaction-icon/mouse-click-drag-icon.js';
import { MouseScrollIcon } from '#components/mouse-interaction-icon/mouse-scroll-icon.js';

/**
 * Static mouse hints for navigating the renderer viewport. Hovering each hint elaborates on the full set of bindings.
 */
export function InteractionHints() {
	return (
		<div className='flex items-center gap-5 text-sm whitespace-nowrap'>
			<Tooltip title={<p className='text-sm'>Right-click and drag to pan around</p>} disableInteractive>
				<div className='flex items-center gap-2'>
					<MouseClickDragIcon side='right' className='-mx-0.25' />
					<span>Pan</span>
				</div>
			</Tooltip>

			<Tooltip title={<p className='text-sm'>Hold Ctrl and scroll to zoom</p>} disableInteractive>
				<div className='flex items-center gap-2'>
					<div className='flex items-center gap-0.5 text-gray-a11'>
						<kbd className='rounded border border-gray-a6 px-0.5 font-mono text-xs'>Ctrl</kbd>
						<span>+</span>
						<MouseScrollIcon className='-mx-1.5' />
					</div>
					<span>Zoom</span>
				</div>
			</Tooltip>
		</div>
	);
}
